import React from "react";

export const DecimalValueColumnFormatter = (cellContent, row) => {
    return Number.isInteger(row.tAmounts) ? row.tAmounts : row.tAmounts.toFixed(2)
}
export const toFixedColumnFormatter = (cellContent) => {
    console.log(cellContent)
    return Number.isInteger(cellContent) ? cellContent : cellContent.toFixed(2)
}
export const toFixedAndEmptyColumnFormatter = (cellContent) => {
    console.log(cellContent)
    if(cellContent === undefined || cellContent === null || cellContent === 0)
    return '-';
    return Number.isInteger(cellContent) ? cellContent : cellContent.toFixed(2)
}
